import React, { useEffect, useState, useContext } from 'react';
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useLocation } from 'react-router-dom';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Typography from '@visa/vds/typography'
import Tab from '@visa/vds/tab';
import TabList from '@visa/vds/tab-list';
import Icon from '@visa/vds/icon';
import MCSOverlayLoading from '../../../components/MCSOverlayLoading';
import UserGroupSettings from "./Components/UserGroupSettings";
import UserManagementSettings from "./Components/UserManagementSettings";
import ExampleNotificationEmail from "./Components/ExampleNotificationEmail";
import { GlobalAlertContext } from "../../../context/GlobalAlertContext";
import { EmailNotificationApi } from 'services/emailNotification.service';

const ManageEmailNotificationSettings = () => {
    // React
    const alertObj = useContext(GlobalAlertContext);
    const location = useLocation();
    const { promiseInProgress } = usePromiseTracker();

    // Data states
    const [emailEvent, setEmailEvent] = useState(location.state.emailEvent);

    // Components states
    const [selectedTab, setSelectedTab] = useState(0);

    const setSelectedSettingTab = (e, k) => {
        setSelectedTab(k);
    };

    const isTabHidden = (tabNo) => {
        return selectedTab === tabNo ? undefined : "hidden";
    };

    const fetchData = async (id) => {
        trackPromise(EmailNotificationApi.GetEmailNotificationEvent(id))
            .then((result) => {
                setEmailEvent(result.data);
            })
            .catch((error) => {
                alertObj.setErrorMessage("Unable to fetch Email Notification Event.")
            })
    }

    useEffect(() => { fetchData(emailEvent.id) }, []);


    return (
        <>
            {promiseInProgress && <MCSOverlayLoading></MCSOverlayLoading>}
            <GlobalAlertContext.Consumer>
                {(alertObj) => (
                    <>
                        <Grid>
                            <Row>
                                <Col>
                                    <Typography tag="h1">Manage Email User Group</Typography>
                                    <Typography tag="h1" variant="title">
                                        Email Notification for {emailEvent.serviceName}
                                    </Typography>
                                    <TabList selectedTab={selectedTab}>
                                        <Tab onClick={setSelectedSettingTab}>
                                            <Icon name="settings" resolution="low" />
                                            User Group Settings
                                        </Tab>
                                        <Tab onClick={setSelectedSettingTab}>
                                            <Icon name="account" resolution="low" />
                                            User Management
                                        </Tab>
                                        <Tab onClick={setSelectedSettingTab}>
                                            <Icon name="email" resolution="low" />
                                            Example Notification Email
                                        </Tab>
                                    </TabList>
                                    <div
                                        id="vds-tab-panel-email-notification-tab-user-group-settings"
                                        hidden={isTabHidden(0)}
                                        tabIndex="0"
                                        role="tabpanel"
                                    >
                                        <UserGroupSettings
                                            emailEvent={emailEvent}
                                            setEmailEvent={setEmailEvent}
                                            alertObj={alertObj}
                                        />
                                    </div>
                                    <div
                                        id="vds-tab-panel-email-notification-tab-user-management"
                                        hidden={isTabHidden(1)}
                                        tabIndex="0"
                                        role="tabpanel"
                                    >
                                        <UserManagementSettings
                                            emailEvent={emailEvent}
                                            alertObj={alertObj}
                                        />
                                    </div>
                                    <div
                                        id="vds-tab-panel-email-notification-tab-email-example"
                                        hidden={isTabHidden(2)}
                                        tabIndex="0"
                                        role="tabpanel"
                                    >
                                        <ExampleNotificationEmail
                                            emailEvent={emailEvent}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Grid>
                    </>
                )}
            </GlobalAlertContext.Consumer>
        </>
    )
}
export default ManageEmailNotificationSettings;